module.exports = __webpack_public_path__ + "static/media/icon_anquan.2f93885d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_anquan.svg
// module id = 261
// module chunks = 0